import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const Unauthorized: React.FC = () => {
  const { user, isTactUser } = useAuth();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="text-center">
          <svg
            className="mx-auto h-24 w-24 text-red-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"
            />
          </svg>
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
            Acesso Negado
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Você não tem permissão para acessar esta página.
          </p>
        </div>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <div className="space-y-6">
            {user && (
              <div className="bg-blue-50 border border-blue-200 rounded-md p-4">
                <div className="flex">
                  <div className="flex-shrink-0">
                    <svg
                      className="h-5 w-5 text-blue-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <div className="ml-3">
                    <h3 className="text-sm font-medium text-blue-800">
                      Informações do seu acesso
                    </h3>
                    <div className="mt-2 text-sm text-blue-700">
                      <p><strong>Nome:</strong> {user.nome_completo}</p>
                      <p><strong>Email:</strong> {user.email}</p>
                      <p><strong>Tipo:</strong> {user.tipo === 'TACT' ? 'Administrador do Sistema' : 'Usuário de Franquia'}</p>
                      {user.franquia_membership && (
                        <>
                          <p><strong>Franquia:</strong> {user.franquia_membership.franquia_nome}</p>
                          <p><strong>Cargos:</strong> {user.franquia_membership.cargos.join(', ')}</p>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="text-center text-sm text-gray-600">
              <p>
                Se você acredita que deveria ter acesso a esta página, entre em contato com:
              </p>
              <ul className="mt-2 space-y-1">
                {isTactUser() ? (
                  <li>• Administrador do sistema</li>
                ) : (
                  <>
                    <li>• Administrador da sua franquia</li>
                    <li>• Suporte técnico</li>
                  </>
                )}
              </ul>
            </div>

            <div className="flex flex-col space-y-3">
              <Link
                to="/"
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#32bef0] hover:bg-[#2ba8d8] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#32bef0]"
              >
                Voltar ao Início
              </Link>
              
              <button
                onClick={() => window.history.back()}
                className="w-full flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#32bef0]"
              >
                Voltar à Página Anterior
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
